import type { MetricConstants } from '@/constants/MetricConstants';
import { RouteName } from '@/constants/RouteName';
import type { AnalysisStep } from '@/types/analytics/AnalysisStep';
import type { ChartTypes } from '@/types/ChartTypes';

export interface AnalysisSubstepComponent {
  name: string;
  subComponents?: AnalysisSubstepComponent[];
}

export type PortfolioConstructionGraphTypes =
  | ChartTypes.TRACK_RECORD
  | ChartTypes.EXPOSURE
  | ChartTypes.EFFICIENT_FRONTIER
  | ChartTypes.ROLLING_VOLATILITY
  | ChartTypes.ROLLING_SHARPE
  | ChartTypes.PERFORMANCE_ATTRIBUTION_GROUP_BY
  | ChartTypes.CUMULATIVE_MONTHLY_RETURN_BREAKDOWN
  | ChartTypes.ROLLING_CORRELATION
  | ChartTypes.CORRELATION
  | ChartTypes.RETURN_REGRESSION
  | ChartTypes.CORRELATION_MATRIX
  | ChartTypes.MST
  | ChartTypes.CUMULATIVE_DRIFT
  | ChartTypes.RECONCILIATION_TABLE
  | ChartTypes.CUMULATIVE_PNL
  | ChartTypes.RANKING_TABLE;

export type FactorDecompositionGraphTypes =
  | ChartTypes.FACTOR_HEATMAP
  | ChartTypes.RETURN_ATTRIBUTION
  | ChartTypes.REGRESSION_TRACK
  | ChartTypes.CUMULATIVE_RESIDUAL
  | ChartTypes.MONTHLY_RETURN
  | ChartTypes.ROLLING;

export interface AnalysisSubstep {
  title: string;
  graphTypes?: PortfolioConstructionGraphTypes[] | FactorDecompositionGraphTypes[];
  metricComponent?: {
    [key in MetricConstants]?: AnalysisSubstepComponent;
  };
  defaultComponents?: AnalysisSubstepComponent;
  historyComponents?: AnalysisSubstepComponent;
  path: string;
}

export const FOLDER: AnalysisStep = {
  // Temporarily Make this into the Portfolio Select modal button
  name: RouteName.FOLDER,
  // route: '/folder',
  route: '',
  disabled: false,
  substeps: [],
  icon: 'folder',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const PERFORMANCE_ATTRIBUTION: AnalysisStep = {
  name: RouteName.PERFORMANCE,
  route: '/performance',
  disabled: false,
  substeps: [],
  icon: 'chart-mixed',
  iconSet: 'fas',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const HOME: AnalysisStep = {
  name: 'Indices',
  route: '/indices',
  disabled: false,
  substeps: [],
  icon: 'fa-regular fa-chart-scatter fa-2x',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const FACTSHEET: AnalysisStep = {
  // TODO: sort out what name this should be...
  name: 'Index Overview',
  route: '/indices/',
  secondaryRoute: '/strategy',
  disabled: false,
  substeps: [],
  icon: 'file-lines',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const CLUSTERING_ANALYSIS: AnalysisStep = {
  name: RouteName.PRINCIPAL_COMPONENT_ANALYSIS,
  route: '/clustering-analysis',
  disabled: true,
  substeps: [],
  icon: 'chart-network',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const BROCHURE_DOWNLOAD: AnalysisStep = {
  name: RouteName.BROCHURE_DOWNLOAD,
  route: '/brochure',
  disabled: false,
  substeps: [],
  icon: 'file-pdf',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const RISK_FACTOR_DOWNLOAD: AnalysisStep = {
  name: RouteName.RISK_FACTOR_DOWNLOAD,
  route: '/risk-factor',
  disabled: false,
  substeps: [],
  icon: 'file-arrow-down',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const ARTICLE: AnalysisStep = {
  name: 'Index Insights',
  route: '/feed',
  disabled: false,
  substeps: [],
  icon: 'lightbulb',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const AI_ARTICLE: AnalysisStep = {
  name: 'AI Insights',
  route: '/ai-feed',
  disabled: false,
  substeps: [],
  icon: 'brain-circuit',
  mobileOnly: false,
  defaultSubstepPath: '',
};

export const MARKET_REGIME_ARTICLE: AnalysisStep = {
  name: 'Market Regime Insights',
  route: '/mr-feed',
  disabled: false,
  substeps: [],
  icon: 'compass',
  mobileOnly: false,
  defaultSubstepPath: '',
};

/**
 * SPECIFIC TO HSBC WHITELABEL APPLICATION SIDEBAR
 */

export const FACTSHEET_DOWNLOAD: AnalysisStep = {
  // TODO: sort out what name this should be...
  name: 'Index Overview Download',
  route: '/factsheet_download',
  secondaryRoute: '',
  disabled: false,
  substeps: [],
  icon: 'file-chart-pie',
  mobileOnly: false,
  // img: 'factsheet',
  defaultSubstepPath: '',
};

export const PERFORMANCE_ATTRIBUTION_DOWNLOAD: AnalysisStep = {
  // TODO: sort out what name this should be...
  name: 'Attribution Download',
  route: '/attribution_download',
  secondaryRoute: '',
  disabled: false,
  substeps: [],
  icon: 'file-chart-column',
  mobileOnly: false,
  // img: 'factsheet',
  defaultSubstepPath: '',
};

export const VIDEO_POPUP: AnalysisStep = {
  // TODO: sort out what name this should be...
  name: 'Video',
  route: '/video-popup',
  secondaryRoute: '',
  disabled: false,
  substeps: [],
  icon: 'clapperboard-play',
  mobileOnly: false,
  // img: 'factsheet',
  defaultSubstepPath: '',
};
